import { Download, Layers, Sparkles, Upload } from "lucide-react";

const steps = [
  {
    icon: Upload,
    title: "1. アップロード",
    body: ".pptx または .pdf をドロップ。最大 50 MB まで。",
  },
  {
    icon: Layers,
    title: "2. 分解 & 解析",
    body: "PPTX はスライドを JSON に分解。PPTX / PDF はレイアウト（要素の位置・種別）を解析。",
  },
  {
    icon: Sparkles,
    title: "3. AI に渡す",
    body: "JSON や AI 向け要約をコピーして ChatGPT / Gemini で編集。",
  },
  {
    icon: Download,
    title: "4. 戻す & 生成",
    body: "編集 JSON から PowerPoint を復元。PDF からは編集可能な PowerPoint を新規生成。",
  },
];

export function HowItWorks() {
  return (
    <section className="mx-auto max-w-6xl px-5 py-12 sm:px-6 sm:py-16">
      <h2 className="mb-8 font-display text-2xl font-medium sm:mb-12 sm:text-3xl">使い方</h2>
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
        {steps.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="rounded-[14px] border border-[var(--color-border)] bg-[var(--color-surface)] p-5 shadow-[var(--shadow-sm)] sm:p-6"
          >
            <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-coral-soft)] text-[var(--color-coral-dark)] sm:mb-4">
              <Icon size={20} />
            </div>
            <h3 className="mb-2 font-display text-base font-medium sm:text-lg">{title}</h3>
            <p className="text-sm text-[var(--color-ink-muted)]">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
